import { createSelector } from 'reselect'

export const getFavouriteAdsFetchedInitially = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.favouriteAds
    ? state.user.profile.favouriteAds.fetchedInitially : false,
    fetchedInitially => fetchedInitially
)
